import { render, staticRenderFns } from "./HandleProductSpecSidebar.vue?vue&type=template&id=f2d0a620&scoped=true&"
import script from "./HandleProductSpecSidebar.vue?vue&type=script&lang=js&"
export * from "./HandleProductSpecSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HandleProductSpecSidebar.vue?vue&type=style&index=0&id=f2d0a620&prod&lang=scss&"
import style1 from "./HandleProductSpecSidebar.vue?vue&type=style&index=1&id=f2d0a620&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d0a620",
  null
  
)

export default component.exports